import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAccessibility } from "../../Store/contexts/AccessibilityContext";
import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons";
import { BackButtonProps } from "../../interfaces/props/BackButtonProps";
import { useNavigate } from "react-router-dom";

function BackButton(props: BackButtonProps) {
    const accessibility = useAccessibility();
    const navigate = useNavigate(); 

    return (
        <button aria-label={props.ariaLabel ?? 'Voltar'} className="back-button" style={accessibility.textStyleAccessibility} onClick={() => {navigate(props.route)}}>
            <FontAwesomeIcon style={accessibility.textStyleAccessibility} icon={faChevronLeft} />&nbsp;&nbsp;<u>Voltar</u>
        </button>
    )
}

export default BackButton;